import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const FpsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        branchCode: z.string(),
        bankCode: z.string(),
    }),
);

export class FpsBankAccountPayload extends BankAccountPayload {
    bankCode: string;
    branchCode: string;
    accountNumber: string;
}
